<template>
  <div class="follow-popup-container">
    <!-- 公众号关注 -->
    <div class="follow-popup ios">
      <nd-dialog v-model="wxQrcodeVisible"  :footer="false">
        <img class="pop-close-button" src="./images/btn_close@2x.png" @click="dismissPopup" />
        <img src="./images/home_popup_ios.png" class="background" />
        <div class="popup-ios-content">
          <div class="content-title" v-html="contentTitle"></div>
          <div class="content-container">
            <img :src="qrCodeUrl" class="qrcode" :show-menu-by-longpress='true' />
            <div class="right">
              <div class="right-item">
                <div class="small-size">长按下载二维码至相册</div>
                <div class="mini-size">微信扫一扫识别关注公众号</div>
              </div>
              <div class="right-item">
                <div class="small-size">点击复制微信号
                  <!-- <span class="orange">{{ appLink }}</span> -->
                </div>
                <div class="mini-size">微信搜索关注公众号</div>
              </div>
            </div>
          </div>

        </div>
        <div class="actions">
          <nd-button class="confirm-button" @click="copyWechatNumber">一键复制去关注</nd-button>
          <div class="cancel-button" @click="dismissPopup">我再看看</div>
        </div>
      </nd-dialog>
    </div>

    <!-- App引导下载 -->
    <div class="follow-popup android">
      <nd-dialog v-model="appPopVisible"  :footer="false">
        <img class="pop-close-button" src="./images/btn_close@2x.png" @click="dismissPopup" />
        <img src="./images/home_popup_android.png" class="background" />
        <div class="content-title" v-html="contentTitle"></div>
        <div class="actions">
          <nd-button class="confirm-button" @click="copyDownloadLink">复制链接到浏览器下载</nd-button>
          <div class="cancel-button" @click="dismissPopup">我再看看</div>
        </div>
      </nd-dialog>
    </div>
  </div>
</template>

<script>
import { judgeClientSystem, copyToClipbord } from '@/assets/utils'
import { mapActions } from 'vuex/dist/vuex.common.js'
export default {
  data () {
    return {
      popConfig: {},
      appPopVisible: false,
      appLink: '',
      appId: '',
      wxQrcodeVisible: false,
      qrCodeUrl: '',
      contentTitle: '',
      type: ''
    }
  },
  methods: {
    ...mapActions(['miniAppGuideCase']),
    async init (type) {
      /**
       * @desc: 获取引流弹窗
       * @return {number} lmtAmt 授信额度
       * @return {number} cycleDay 展示周期
       * @return {string} qrCodeUrl 二维码链接
       * @return {string} copyValue 复制值安卓下载链接，ios公众号
       * @return {string} showType PACKAGE:马甲包; WECHAT_MP:微信公众号; APP:app
       */
      
      const { success, data } = await this.miniAppGuideCase({
        guideCaseType: type === 'AUTH_RESULT' ? 'CREDIT' : 'LOAN'
      })
      if (success) { 
        const { qrCodeUrl, copyValue, lmtAmt, showType, showGuide } = data
        if (showGuide === 'N') return 
        this.qrCodeUrl = qrCodeUrl
        this.appLink = copyValue
        const _contentTitle = {
          AUTH_RESULT_WX: `进入公众号立领<span class="orange">${lmtAmt}</span>元额度`,
          AUTH_RESULT_APP: `进入App立领<span class="orange">${lmtAmt}</span>元额度`,
          WITHDRAW_RESULT_WX: `进入公众号立获<span class="orange">3000</span>元提额机会`,
          WITHDRAW_RESULT_APP: `进入App立获<span class="orange">3000</span>元提额机会`
        }
        const _type = showType === 'WECHAT_MP' ? '_WX' : '_APP'
        this.contentTitle = _contentTitle[`${type}${_type}`]
        if (['WECHAT_MP'].includes(showType)) {
          this.wxQrcodeVisible = true
        } else {
          this.appPopVisible = true
        }
      }
    },
    copyWechatNumber () {
      copyToClipbord(this.appLink)
      this.$message('复制成功', 2000)
      this.dismissPopup()
    },
    copyDownloadLink () {
      if (judgeClientSystem() === 'IOS') {
        copyToClipbord(`itms-appss://apps.apple.com/cn/app/id${this.appLink}`)
      } else {
        copyToClipbord(this.appLink)
      }
      this.$message('复制成功', 2000)
      this.dismissPopup()
    },
    dismissPopup () {
      this.wxQrcodeVisible = false
      this.appPopVisible = false
    }
  }
}
</script>


<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.follow-popup-container {
  .follow-popup {
    .pop-close-button {
      width: 60px;
      height: 60px;
      position: absolute;
      top: -80px;
      right: 20px;
      z-index: 999999;
    }
    /deep/.orange {
      color: #FF4633;
    }

    &.ios {
      position: relative;

      .background {
        position: absolute;
        top: 0;
        left: 0;
        width: 620px;
        height: 730px;
        z-index: 1;
      }

      .popup-ios-content {
        display: flex;
        flex-direction: column;
        z-index: 2;
        margin: 0 auto;
        margin-top: 180px;
        position: relative;

        .content-title {
          font-size: 36px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #111111;
          line-height: 50px;
          display: flex;
          justify-content: center;
        }

        .content-container {
          display: flex;
          flex-direction: row;
          margin-top: 24px;
          justify-content: center;

          .qrcode {
            width: 188px;
            height: 188px;
          }

          .right {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-left: 16px;

            .right-item {
              background-color: #f7f7f7;
              height: 84px;
              width: 300px;
              position: relative;
              display: flex;
              flex-direction: column;
              justify-content: center;
              padding-left: 20px;

              .small-size {
                font-size: 24px;
                color: #333333;
                line-height: 33px;
                font-weight: bold;
              }

              .mini-size {
                font-size: 20px;
                font-weight: 400;
                color: #9c9c9c;
                line-height: 28px;
              }
            }
          }
        }

        
      }

      .actions {
        margin-top: 34px;
        z-index: 2;
        position: relative;
        .confirm-button {
          font-size: 32px;
          text-align: center;
          margin: 0 auto;
          line-height: 80px;
        }
      }
    }

    &.android {
      position: relative;
      .content-title {
        font-size: 36px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #111111;
        line-height: 50px;
        display: flex;
        justify-content: center;
        position: relative;
        z-index: 2;
        margin-top: 200px;
      }
      .background {
        position: absolute;
        top: 0;
        left: 0;
        width: 620px;
        height: 730px;
        z-index: 1;
      }

      .actions {
        margin-top: 260px;
        z-index: 2;
        position: relative;

        .confirm-button {
          font-size: 32px;
          text-align: center;
          margin: 0 auto;
          line-height: 80px;
        }
      }
    }

    .title {
      font-size: 42px;
      font-weight: 600;
      color: #111;
      line-height: 59px;
    }

    .privacy-content {
      margin-top: 20px;
      font-size: 28px;
      font-weight: 400;
      color: #333333;
      line-height: 40px;

      .link {
        color: #8eb2d8;
      }
    }

    .actions {
      margin-top: 41px;
    }

    .confirm-button {
      font-size: 32px;
      width: 460px;
      height: 80px;
      background-color: #FF4633;
      color: white;
      border-radius: 40px;
    }

    .cancel-button {
      height: 40px;
      font-size: 28px;
      font-weight: 400;
      color: #aaaaaa;
      line-height: 40px;
      margin-top: 40px;
      text-align: center;
    }
  }
}
</style>